import React from 'react';
import styled from 'styled-components';
import {Spinner} from './Spinner';

const SpinnerLoaderContainer = styled.div`
    background: var(--container-background-color-backdrop);
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 4000;
    ${Spinner} {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: var(--white-00);
    }

    ${({fixed}) => {
        if (fixed)
            return `
            position: fixed;
        `;
    }}
`;

const SpinnerLoader = ({children, fixed}) => (
    <SpinnerLoaderContainer fixed={fixed}>
        <Spinner></Spinner>
        {children}
    </SpinnerLoaderContainer>
);

export {SpinnerLoaderContainer, SpinnerLoader};
